// extracted by mini-css-extract-plugin
export default {"header":"SiteHeader_header__097zm","brand":"SiteHeader_brand__nwKy3","navigation":"SiteHeader_navigation__gKgk+"};